export const initialState: IGroupsState = {
  groupInfo: {
    loading: false,
    error: false,
    data: []
  },
  groupTagSvgs: [],
  groupTagLabels: [],
  groupAdmins: {
    loading: false,
    data: []
  },
  interventions: {
    managed: [],
    userCreated: []
  },
  timeLogTasks: [],
  timeLogTypes: [],
  carePrograms: [],
  observationCollections: [],
  deviceOrderingsAvailable: [],
  questionnaires: {
    loading: false,
    error: false,
    data: []
  },
  groupAvatar: null,
  groupNotifyActivities: {
    loading: false,
    error: false,
    data: null
  },
  selectedGid: 'all',
  lastSelectedGid: null,
  selectedPatients: [],
  lastOpenedUid: ''
};
